import { keyframes } from 'styled-components';

export const pulse = keyframes`
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255 255 255 / .5);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 50px rgba(255 255 255 / 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(255 255 255 / 0);
  }
`;

export const bounce = height => keyframes`
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(${height});
  }
`;

export const dash = keyframes`
  from {
    stroke-dashoffset: 800;
  }
  to {
    stroke-dashoffset: 0;
  }
`;

export const pulseCallout = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
  }
  70%,
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
`;
